import React, { useEffect, useState } from "react";
import {
    Stack,
    Grid,
    Box,
    Typography,
    Button,
    TextField,
    InputAdornment,
} from "@mui/material";
import axios from "axios";
import { getEnvironment } from "../utils/getEnvironment";

const environment = getEnvironment();

const DefaultServiceAdmin = () => {
    const [services, setServices] = useState<any[]>([]);

    useEffect(() => {
        axios
            .get(environment.api_url + "/business/api/v9/x3l7gq/321")
            .then((response) => setServices(response.data))
            .catch((error) => console.error("Error fetching services", error));
    }, []);

    // Handle changes in input fields
    const handleChange = (serviceId: string, field: string, value: any) => {
        setServices((prevServices) =>
            prevServices.map(
                (service) =>
                    service.serviceId === serviceId
                        ? { ...service, [field]: value } // Only update the modified service
                        : service // Leave the other services unchanged
            )
        );
    };

    // Save the edited service
    const handleSave = (serviceId: string) => {
        const service = services.find((s) => s.serviceId === serviceId);
        if (service) {
            axios
                .put(
                    `${environment.api_url}/business/api/v9/x3l7gq/321/update/${serviceId}`,
                    service
                )
                .then((response) => {
                    // Update the list of services after the save
                    setServices((prevServices) =>
                        prevServices.map((s) =>
                            s.serviceId === serviceId ? { ...s, ...service } : s
                        )
                    );
                })
                .catch((error) => console.error("Error saving service", error));
        }
    };

    return (
        <Stack spacing={2} width="100%" padding={2}>
            <Typography variant="h4">All Business Services</Typography>
            <Grid container spacing={2}>
                {services.map((service) => (
                    <Grid item xs={12} sm={6} md={4} key={service.serviceId}>
                        <Box
                            padding={2}
                            bgcolor="white"
                            borderRadius="8px"
                            boxShadow="0 4px 10px rgba(0, 0, 0, 0.1)"
                        >
                            {/* Display Business Type and Category Name (Read-Only) */}
                            <Typography variant="body1" fontWeight={600}>
                                Business: {service.businessName}
                            </Typography>
                            <Typography variant="body2" color="textSecondary">
                                Category: {service.categoryName}
                            </Typography>
                            {/* Editable Fields */}
                            <TextField
                                label="Service Name"
                                value={service.serviceName || ""}
                                onChange={(e) =>
                                    handleChange(
                                        service.serviceId,
                                        "serviceName",
                                        e.target.value
                                    )
                                }
                                fullWidth
                                margin="normal"
                            />
                            <TextField
                                label="Description"
                                value={service.description || ""}
                                onChange={(e) =>
                                    handleChange(
                                        service.serviceId,
                                        "description",
                                        e.target.value
                                    )
                                }
                                fullWidth
                                margin="normal"
                            />
                            <TextField
                                label="Price"
                                type="number"
                                value={service.price || ""}
                                onChange={(e) =>
                                    handleChange(
                                        service.serviceId,
                                        "price",
                                        e.target.value
                                    )
                                }
                                fullWidth
                                margin="normal"
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            €
                                        </InputAdornment>
                                    ),
                                }}
                            />
                            <TextField
                                label="Duration (min)"
                                type="number"
                                value={service.duration || ""}
                                onChange={(e) =>
                                    handleChange(
                                        service.serviceId,
                                        "duration",
                                        e.target.value
                                    )
                                }
                                fullWidth
                                margin="normal"
                            />
                            <TextField
                                label="Image URL"
                                value={service.image || ""}
                                onChange={(e) =>
                                    handleChange(
                                        service.serviceId,
                                        "image",
                                        e.target.value
                                    )
                                }
                                fullWidth
                                margin="normal"
                            />

                            {/* Save Button */}
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={() => handleSave(service.serviceId)}
                            >
                                Save Changes
                            </Button>
                        </Box>
                    </Grid>
                ))}
            </Grid>
        </Stack>
    );
};

export default DefaultServiceAdmin;
